module.exports = __webpack_public_path__ + "static/img/IMG_0599-1.60bb53a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-konyhahatfal/barna/IMG_0599-1.jpg
// module id = 570
// module chunks = 0